import 'dayjs/locale/zh-cn'

import { ConfigProvider } from 'antd'
import { Spin } from 'antd'
import zhCN from 'antd/locale/zh_CN'
// 这个是全局的页面 还可以做一些其他的操作
import { AnimatePresence, motion } from 'framer-motion'
import { Outlet, useLocation } from 'react-router-dom'

// import { Dialog_kefu_button } from "@/views/Dialog_kefu_button"
import { Dialog_kefu_button } from '@/components/Dialog_kefu_button'
import GlobalQuickDock, { shouldShowGlobalQuickDock } from '@/components/GlobalQuickDock'
import { getPageTransitionKey } from '@/router/pageTransition'
import { useGlobalStore } from '@/store/global'
import { useNavigationMenusStore } from '@/store/navigation-menus'
import Footer from '@/views/Footer'
import Header from '@/views/Header'

const excludePath = ['/order']

export default function App() {
  const { globalLoading, globalTip, officialData, getOfficialData } = useGlobalStore((state) => state)

  const location = useLocation()
  const isAiWorkspace = /^\/ai\/imageTo3d/.test(location.pathname)
  const isAiPricingLayout = /^\/ai\/(pricing|member)/.test(location.pathname)
  const isAiFullBleed = isAiWorkspace || isAiPricingLayout

  const isHomeMall = /^\/home/.test(location.pathname)
  const showGlobalQuickDock = shouldShowGlobalQuickDock(location.pathname)

  const pageVariants =
    isAiFullBleed || isHomeMall
      ? {
          initial: { opacity: 0 },
          in: { opacity: 1 },
          out: { opacity: 0 },
        }
      : {
          initial: {
            opacity: 0,
            scale: 0.8,
          },
          in: {
            opacity: 1,
            scale: 1,
          },
          out: {
            opacity: 0,
            scale: 0.8,
          },
        }
  useEffect(() => {
    getOfficialData()
    useNavigationMenusStore.getState().fetchMenus()
  }, [])
  return (
    <ConfigProvider locale={zhCN}>
      <Spin tip={globalTip} spinning={globalLoading} size="large">
        <div className="relative ">
          {/* 固定顶部Header - 全屏宽度 */}
          <div className="fixed top-0 left-0 z-50 box-border h-[var(--ui-header-height)] w-full border-b border-[#e5e7eb] bg-white">
            <Header officialData={officialData} />
          </div>

          {/* 为固定 Header 留出空间（与 Header 高度一致） */}
          <div className={`pt-[var(--ui-header-height)] ${showGlobalQuickDock ? 'global-quick-dock-page' : ''}`}>
            <AnimatePresence mode="wait">
              <div>
                <motion.div
                  key={getPageTransitionKey(location)}
                  initial="initial"
                  animate="in"
                  exit="out"
                  variants={pageVariants}
                  transition={{ duration: isAiFullBleed || isHomeMall ? 0.2 : 0.6 }}
                  style={{
                    minHeight:
                      isAiFullBleed || isHomeMall ? 'calc(100vh - var(--ui-header-height))' : 'calc(100vh - 360px)',
                  }}
                  className={
                    isAiFullBleed
                      ? 'w-full h-full'
                      : isHomeMall
                        ? 'w-full flex justify-center items-start px-[10px]'
                        : 'flex justify-center items-center px-[10px]'
                  }
                >
                  <Outlet />
                </motion.div>
              </div>
            </AnimatePresence>
          </div>
        </div>

        {/* Footer组件 - 全屏宽度，不受max-w限制 */}
        {excludePath.includes(location.pathname) || isAiWorkspace || (
          <div className="w-full">
            <Footer officialData={officialData} />
          </div>
        )}

        {/* 客服弹框：快捷栏统一入口，隐藏旧版右下角悬浮球 */}
        <Dialog_kefu_button url_no={['/order', '/merchantcenter']} button_hidden_no={['']} />

        {showGlobalQuickDock ? <GlobalQuickDock /> : null}
      </Spin>
    </ConfigProvider>
  )
}
